var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.tariffCard
  }, [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', [_c('v-text', {
    attrs: {
      "type": "title",
      "light": ""
    }
  }, [_vm._t("default")], 2)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dcb3338","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariffCard/TariffCard.vue
// module id = 978
// module chunks = 0